module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    class: [_vm.settingsObj.themeColor, 'darken-4', 'primary'],
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (function () { return _vm.emitEvent('toggleDrawer'); })($event)
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(this.getRouteName()))]), _vm._v(" "), _c('v-spacer', {
    attrs: {
      "mr-3": ""
    }
  }), _vm._v(" "), _c('v-fab-transition', [(_vm.settingsObj.infoBtn) ? _c('v-btn', {
    class: [_vm.settingsObj.themeColor, 'darken-4', 'elevation-0', 'info-btn'],
    attrs: {
      "fab": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        (function () { return _vm.emitEvent('toggleInfo', {
          showInfo: _vm.getPageInfo()
        }); })($event)
      }
    }
  }, [_c('v-icon', [_vm._v("help_outline")])], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-40a1b366","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 463
// module chunks = 0